import { Tooltip } from 'antd'
import type { BulkOrderUpdateJobSummaryResponse } from '@api/useBulkOrderUpdate/types'

interface OutcomeCountsRendererProps {
  data: BulkOrderUpdateJobSummaryResponse
}

export function OutcomeCountsRenderer({ data }: OutcomeCountsRendererProps) {
  const { successful_updates, no_action_taken, failed_updates, total_count } = data

  const tooltipContent = (
    <div>
      <div>✅ Completed</div>
      <div>⚠️ No Change</div>
      <div>❌ Errors</div>
    </div>
  )

  return (
    <Tooltip title={tooltipContent} placement='top'>
      <div className='flex gap-1 cursor-help min-w-32'>
        <span className='text-gray-500 text-xs w-6'>{total_count || 0}</span>
        <span className='text-green-600 text-xs w-8 min-w-8'>
          {(successful_updates || 0) > 0 ? `✅ ${successful_updates}` : ''}
        </span>
        <span className='text-yellow-600 text-xs w-8 min-w-8'>
          {(no_action_taken || 0) > 0 ? `⚠️ ${no_action_taken}` : ''}
        </span>
        <span className='text-red-600 text-xs w-8 min-w-8'>
          {(failed_updates || 0) > 0 ? `❌ ${failed_updates}` : ''}
        </span>
      </div>
    </Tooltip>
  )
}
